/**
 * Semantic v2 names (layoutXl etc.) are the standard going forward.
 * Legacy v1 names (baseLayoutXL etc.) are kept as aliases during migration.
 *
 *  FIGMA reference:
 *  https://www.figma.com/design/CqO24eewdxuBg3MkLbj2QX/BHB-components?node-id=6112-51415&t=cqV7qec26xmWuSV7-0
 */
import { BreakpointsOptions, createTheme } from "@mui/material/styles";

const defaultTheme = createTheme();

export const breakpointValues = {
  // v2 — use these going forward
  layoutXl: 1920,
  layoutLg: 1440,
  layoutMd: 1366,
  layoutSm: 1024,

  // v1 aliases — same values, deprecated names
  /** @deprecated use layoutXl */
  baseLayoutXL: 1920,
  /** @deprecated use layoutLg */
  baseLayoutL: 1440,
  /** @deprecated use layoutMd */
  baseLayoutMD: 1366,
  /** @deprecated use layoutSm */
  baseLayoutSM: 1024
} as const;

export const buildBreakpoints = (): BreakpointsOptions => ({
  values: {
    ...defaultTheme.breakpoints.values,
    ...breakpointValues
  }
});
